import { apiCall } from '@/lib/api-client';
import type { DailyStats, WeeklyTierStats } from '@/types/api';

export interface DashboardMetric {
  todayTarget: { completed: number; target: number; pct: number };
  completionRate: { completed: number; attempts: number; pct: number };
  upcomingBookings: { count: number; next7Days: number };
  activeWorkTime: { seconds: number; targetSeconds: number; pct: number };
  patientStatusBreakdown: Array<{ status: string; count: number }>;
}

export interface TeamDashboard {
  team: DashboardMetric;
  perAgent: Array<{
    agentId: string;
    agentName: string;
    todayCompleted: number;
    todayTarget: number;
    activeWorkSeconds: number;
  }>;
}

export interface UploadStatus {
  submittedToday: number;
  uploadedToFindhelp: number;
  pendingUpload: number;
  uploadedPercent: number;
  overdue24h: Array<{
    id: string;
    submittedAt: string;
    hoursSinceSubmit: number;
    cinHashSuffix: string;
  }>;
}

export const agentMetricsApi = {
  today: () => apiCall<DailyStats>('/agents/me/today'),
  tier: () => apiCall<WeeklyTierStats>('/agents/me/tier'),
  dashboard: () => apiCall<DashboardMetric>('/agents/me/dashboard'),
  teamDashboard: () => apiCall<TeamDashboard>('/admin/dashboard/team'),
  uploadStatus: () => apiCall<UploadStatus>('/agents/me/upload-status'),
};
